import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { FormControl } from '@angular/forms';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from '@node_modules/rxjs';
import { Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import {
  ActivityDaysServiceProxy,
  AllocatedMaterialDto,
  AllocateMaterialForActivityDayInput,
  UpdateAllocatedMaterialListForActivityDayInput,
} from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-assign-materials',
  templateUrl: './assign-materials.component.html',
  styleUrls: ['./assign-materials.component.less'],
})
export class AssignMaterialsComponent
  extends AppComponentBase
  implements OnInit, AfterViewInit {
  @ViewChild('materialsSelector', { static: true }) materialsSelector: MatSelect;

  @Input() allowedMaterials: any;
  @Input() activityDayId: string;
  _allocatedMaterials: any;
  @Input() set allocatedMaterials(value: any) {
    this._allocatedMaterials = value;
    const allocated = this.getValueforMaterialsFormCtrl()
    this.materialsFormCtrl.setValue(allocated);
  }
  get allocatedMaterials(): any {
    return this._allocatedMaterials;
  }
  @Input() anyResourceSelected: boolean;

  @Output()
  onAssignedCounterUpdate: EventEmitter<number> = new EventEmitter<number>();
  @Input() componentMode: 'allocationSheet' | 'default' = 'default';

  @Output() showActivityPanel: EventEmitter<any> = new EventEmitter<any>();
  @Input() controlDisabled: boolean;

  public materialsFormCtrl: FormControl = new FormControl();
  public materialsFilterFormCtrl: FormControl = new FormControl();
  public filteredMaterials: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  protected _onDestroy = new Subject<void>();

  constructor(
    injector: Injector,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  updateTotals() {
    let personnelSum = 0;
    this.materialsFormCtrl.value.forEach(
      (item) => (personnelSum += parseInt(item.hours))
    );
    this.onAssignedCounterUpdate.emit(personnelSum);
  }

  showError(): boolean {
    const selectedMaterial = this.materialsFormCtrl?.value;
    const total = selectedMaterial && selectedMaterial.length >0 ?selectedMaterial.map(x=>x.hours).reduce((a, b) => { return a + b }):0;
    return total<=0
  }

  addOrRemoveMaterial(material) {
    if (
      this.materialsFormCtrl.value.some(
        (item) => item.serialNumber === material.serialNumber
      )
    ) {
      //add to list
      const params = new AllocateMaterialForActivityDayInput({
        activityDayId: this.activityDayId,
        material: new AllocatedMaterialDto({
          actualHours: 0,
          materialId: material.id,
        }),
      });
      this._activityDaysServiceProxy.allocateMaterial(params).subscribe(() => {});
    } else {
      this._activityDaysServiceProxy
        .removeAllocatedMaterial(this.activityDayId, material.id)
        .subscribe(() => {});
    }

    this.updateTotals();
  }

  ngAfterViewInit() {
    this.setInitialMaterialSelectorValues();
  }

  setInitialMaterialSelectorValues() {
    this.filteredMaterials
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.materialsSelector.compareWith = (a: any, b: any) => {
          return a && b && a.id === b.id;
        };
      });
  }

  ngOnInit(): void {
    if (this.allowedMaterials) {
      const allowed = [...this.allowedMaterials].map((item) => {
        let hrs = 0;

        this.allocatedMaterials.allocatedMaterials.forEach((allocated) => {
          if (allocated.materialId === item.id) {
            hrs = allocated.actualHours;
          }
        });

        return {
          ...item,
          hours: hrs,
        };
      });

      this.allowedMaterials = allowed;
      this.cdr.detectChanges();
    }

    if (this.allowedMaterials) {
      this.filteredMaterials.next(this.allowedMaterials.slice());
    }

    if (this.allocatedMaterials && this.allocatedMaterials.allocatedMaterials) {
      const allocated = this.getValueforMaterialsFormCtrl();

      this.materialsFormCtrl.setValue(allocated);
    }

    // this.updateTotals();

    this.materialsFilterFormCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterMaterials();
      });
  }

  getValueforMaterialsFormCtrl(){
    return  [...this.allocatedMaterials.allocatedMaterials].map(
      (item) => {
        return {
          // ...item,
          id: item.materialDetails.materialId,
         
          supplier: item.materialDetails.supplier,
          name:item.materialDetails.name,
          hours: item.actualHours,
        };
      }
    );
  }
  protected filterMaterials() {
    if (!this.allowedMaterials) {
      return;
    }

    let search = this.materialsFilterFormCtrl.value;
    if (!search) {
      this.filteredMaterials.next(this.allowedMaterials.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredMaterials.next(
      this.allowedMaterials?.filter(
        (material) =>
          `${material.supplier.toLowerCase()}`.includes(search) ||
          `${material.materialId.toLowerCase()}`.includes(search) ||
          `${material.supplier.toLowerCase()} (${material.serialNumber.toLowerCase()})`.includes(
            search
          )
      )
    );
  }

  removeItem(materialId: string) {
    this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
      if (isConfirmed) {
        const filtered = this.materialsFormCtrl.value?.filter(
          (material) => material.id != materialId
        );
        this.materialsFormCtrl.setValue(filtered);
        this._activityDaysServiceProxy
          .removeAllocatedMaterial(this.activityDayId, materialId)
          .subscribe(() => {
            this.updateTotals();
          });

        this.cdr.detectChanges();
      }
    });
  }

  updateAllocatedMaterialsList() {
    const params = new UpdateAllocatedMaterialListForActivityDayInput({
      activityDayId: this.activityDayId,
      materials: [...this.materialsFormCtrl.value].map((item) => {
        return new AllocatedMaterialDto({
          actualHours: parseInt(item.hours) || 0,
          materialId: item.id,
        });
      }),
    });

    this._activityDaysServiceProxy
      .updateAllocateMaterialList(params)
      .subscribe(() => {
        this.updateTotals();
      });
  }

  isAllocationSheet() {
    return this.componentMode === 'allocationSheet';
  }

  edit() {
    this.showActivityPanel.emit();
  }
}
